import { createContext } from "react";
import  useFadeOutAlert  from "@templates/shared-theme/components/useFadeOutAlert";

export const AlertContext = createContext(null);

export const AlertProvider = ({ children }) => {
    const { addAlertBanner, alertsContainer } = useFadeOutAlert();

    return (
      <AlertContext.Provider value={{addAlertBanner}}>
        {alertsContainer}
        {children}
      </AlertContext.Provider>
    );
};